"use client"

import * as React from "react"
import { Button, Separator } from "@ui/shad"
import { Calendar, Loader2, Send } from "lucide-react"

import { cn } from "../utils"
import { ScheduleModal } from "./schedule-modal"
import type { ScheduledSendButtonProps } from "./types"

export function ScheduledSendButton({
  onSend,
  onSchedule,
  sendLabel = "Send",
  sendingLabel = "Sending...",
  sendIcon = <Send className="size-4" />,
  disabled = false,
  sending = false,
  scheduling = false,
  className,
  recipientTimezone,
}: ScheduledSendButtonProps) {
  const [modalOpen, setModalOpen] = React.useState(false)
  const isLoading = sending || scheduling

  const handleScheduleConfirm = async (scheduledFor: string) => {
    await onSchedule(scheduledFor)
    setModalOpen(false)
  }

  return (
    <>
      <div className={cn("flex", className)}>
        <Button size="sm" onClick={onSend} disabled={disabled || isLoading} className="rounded-r-none">
          {sending ? (
            <>
              <Loader2 className="size-4 animate-spin" />
              {sendingLabel}
            </>
          ) : (
            <>
              {sendIcon}
              {sendLabel}
            </>
          )}
        </Button>

        <Separator orientation="vertical" className="bg-muted-foreground h-auto" />

        <Button
          size="sm"
          disabled={disabled || isLoading}
          className="rounded-l-none border-l-0 px-2"
          onClick={() => setModalOpen(true)}
        >
          {scheduling ? <Loader2 className="size-4 animate-spin" /> : <Calendar className="size-4" />}
        </Button>
      </div>

      <ScheduleModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        onConfirm={handleScheduleConfirm}
        disabled={scheduling}
        recipientTimezone={recipientTimezone}
      />
    </>
  )
}
